(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const initializedCollectionLoadMore = new WeakSet();

  const initCollectionLoadMore = (root) => {
    if (!(root instanceof HTMLElement) || initializedCollectionLoadMore.has(root)) return;

    const button = root.querySelector('[data-load-more-button]');
    const status = root.querySelector('[data-load-more-status]');

    if (!(button instanceof HTMLAnchorElement) || !(status instanceof HTMLElement)) return;

    initializedCollectionLoadMore.add(root);

    let isLoading = false;
    let observer;

    const disconnectObserver = () => {
      if (observer) observer.disconnect();
    };

    const reconnectObserver = () => {
      if (root.dataset.autoLoad !== 'true' || !('IntersectionObserver' in window) || !button.isConnected) return;

      disconnectObserver();

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) loadNextPage();
          });
        },
        { rootMargin: '240px 0px' }
      );

      observer.observe(button);
    };

    const setIdleState = () => {
      isLoading = false;
      root.removeAttribute('aria-busy');

      if (button.isConnected) {
        button.removeAttribute('aria-disabled');
        button.textContent = root.dataset.loadMoreLabel || button.textContent;
      }
    };

    const loadNextPage = async () => {
      if (isLoading || !button.href) return;

      isLoading = true;
      root.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      button.textContent = root.dataset.loadingLabel || button.textContent;
      status.textContent = root.dataset.loadingLabel || '';
      disconnectObserver();

      try {
        const response = await fetch(button.href, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch the next collection page');

        const html = await response.text();
        const nextDocument = new DOMParser().parseFromString(html, 'text/html');
        const selector = `[data-collection-grid][data-section-id="${root.dataset.sectionId}"]`;
        const currentGrid = document.querySelector(selector);
        const nextGrid = nextDocument.querySelector(selector);

        if (!(currentGrid instanceof HTMLElement) || !(nextGrid instanceof HTMLElement)) {
          throw new Error('Collection grid not found');
        }

        const nextItems = Array.from(nextGrid.children);

        if (!nextItems.length) {
          throw new Error('No collection items found');
        }

        currentGrid.append(...nextItems);

        const nextButton = nextDocument.querySelector(
          `[data-collection-load-more][data-section-id="${root.dataset.sectionId}"] [data-load-more-button]`
        );

        if (nextButton instanceof HTMLAnchorElement) {
          button.href = nextButton.href;
          status.textContent = '';
          setIdleState();
          reconnectObserver();
          return;
        }

        button.remove();
        root.removeAttribute('aria-busy');
        status.textContent = root.dataset.endLabel || '';
        disconnectObserver();
        isLoading = false;
      } catch (error) {
        setIdleState();
        status.textContent = root.dataset.errorLabel || '';
      }
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      loadNextPage();
    });

    reconnectObserver();
  };

  const mountCollectionLoadMore = (scope = document) => {
    if (!(scope instanceof Element) && !(scope instanceof Document)) return;
    scope.querySelectorAll('[data-collection-load-more]').forEach((root) => initCollectionLoadMore(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountCollectionLoadMore(), { once: true });
  } else {
    mountCollectionLoadMore();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    mountCollectionLoadMore(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  const initializedBlogLoadMore = new WeakSet();

  const initBlogLoadMore = (root) => {
    if (!(root instanceof HTMLElement) || initializedBlogLoadMore.has(root)) return;

    const button = root.querySelector('[data-load-more-button]');
    const status = root.querySelector('[data-load-more-status]');

    if (!(button instanceof HTMLAnchorElement) || !(status instanceof HTMLElement)) return;

    initializedBlogLoadMore.add(root);

    let isLoading = false;
    let observer;

    const disconnectObserver = () => {
      if (observer) observer.disconnect();
    };

    const reconnectObserver = () => {
      if (root.dataset.autoLoad !== 'true' || !('IntersectionObserver' in window) || !button.isConnected) return;

      disconnectObserver();

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) loadNextPage();
          });
        },
        { rootMargin: '240px 0px' }
      );

      observer.observe(button);
    };

    const setIdleState = () => {
      isLoading = false;
      root.removeAttribute('aria-busy');

      if (button.isConnected) {
        button.removeAttribute('aria-disabled');
        button.textContent = root.dataset.loadMoreLabel || button.textContent;
      }
    };

    const loadNextPage = async () => {
      if (isLoading || !button.href) return;

      isLoading = true;
      root.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      button.textContent = root.dataset.loadingLabel || button.textContent;
      status.textContent = root.dataset.loadingLabel || '';
      disconnectObserver();

      try {
        const response = await fetch(button.href, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch the next blog page');

        const html = await response.text();
        const nextDocument = new DOMParser().parseFromString(html, 'text/html');
        const selector = `[data-blog-grid][data-section-id="${root.dataset.sectionId}"]`;
        const currentGrid = document.querySelector(selector);
        const nextGrid = nextDocument.querySelector(selector);

        if (!(currentGrid instanceof HTMLElement) || !(nextGrid instanceof HTMLElement)) {
          throw new Error('Blog grid not found');
        }

        const nextItems = Array.from(nextGrid.children);

        if (!nextItems.length) {
          throw new Error('No blog items found');
        }

        currentGrid.append(...nextItems);

        const nextButton = nextDocument.querySelector(
          `[data-blog-load-more][data-section-id="${root.dataset.sectionId}"] [data-load-more-button]`
        );

        if (nextButton instanceof HTMLAnchorElement) {
          button.href = nextButton.href;
          status.textContent = '';
          setIdleState();
          reconnectObserver();
          return;
        }

        button.remove();
        root.removeAttribute('aria-busy');
        status.textContent = root.dataset.endLabel || '';
        disconnectObserver();
        isLoading = false;
      } catch (error) {
        setIdleState();
        status.textContent = root.dataset.errorLabel || '';
      }
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      loadNextPage();
    });

    reconnectObserver();
  };

  const mountBlogLoadMore = (scope = document) => {
    if (!(scope instanceof Element) && !(scope instanceof Document)) return;
    scope.querySelectorAll('[data-blog-load-more]').forEach((root) => initBlogLoadMore(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountBlogLoadMore(), { once: true });
  } else {
    mountBlogLoadMore();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    mountBlogLoadMore(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Quantity selector buttons
  document.addEventListener('click', function(evt) {
    const btn = evt.target.closest('.quantity__button');
    if (!(btn instanceof HTMLElement) || !btn.closest('.product-form__quantity')) return;
    const input = btn.parentElement.querySelector('.quantity__input');
    if (!input) return;
    const current = parseInt(input.value) || 1;
    if (btn.name === 'minus' && current > 1) {
      input.value = current - 1;
    } else if (btn.name === 'plus') {
      input.value = current + 1;
    }
    input.dispatchEvent(new Event('change'));
  });

  document.addEventListener('click', async function(evt) {
    const copyButton = evt.target.closest('[data-copy-product-link]');

    if (!(copyButton instanceof HTMLButtonElement)) return;

    evt.preventDefault();

    const label = copyButton.querySelector('[data-copy-link-label]');
    const defaultLabel = copyButton.dataset.defaultLabel || label?.textContent?.trim() || 'Copy Link';
    copyButton.dataset.defaultLabel = defaultLabel;

    try {
      await navigator.clipboard.writeText(window.location.href);
      if (label instanceof HTMLElement) {
        label.textContent = 'Copied!';
      }
    } catch (error) {
      console.error(error);
      if (label instanceof HTMLElement) {
        label.textContent = 'Copy failed';
      }
    }

    window.clearTimeout(Number(copyButton.dataset.resetTimer || 0));
    const resetTimer = window.setTimeout(() => {
      if (label instanceof HTMLElement) {
        label.textContent = defaultLabel;
      }
      delete copyButton.dataset.resetTimer;
    }, 1800);

    copyButton.dataset.resetTimer = String(resetTimer);
  });

  const formatProductMoney = (cents, moneyFormat) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  };

  // Media Gallery Slider Logic
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.slider = this.querySelector('[id^="Slider-Gallery"]');
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      this.currentCounter = this.querySelector('.slider-counter--current');
      this.slides = Array.from(this.querySelectorAll('.product__media-item'));

      if (!this.slider || !this.nextButton || !this.prevButton) return;

      this.nextButton.addEventListener('click', () => {
        this.slider.scrollBy({ left: this.slider.clientWidth, behavior: 'smooth' });
      });
      this.prevButton.addEventListener('click', () => {
        this.slider.scrollBy({ left: -this.slider.clientWidth, behavior: 'smooth' });
      });

      this.slider.addEventListener('scroll', () => {
        this.updateControls();
      });

      setTimeout(() => this.updateControls(), 100);
    }

    setActiveMedia(mediaId) {
      this.slides.forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.mediaId === `${mediaId}`);
      });
    }

    scrollToMedia(mediaId) {
      if (!this.slider || !mediaId) return;

      const targetSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!(targetSlide instanceof HTMLElement)) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setActiveMedia(mediaId);
      this.slider.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
      this.updateControls();
    }

    updateControls() {
      const slideScrollPosition = this.slider.scrollLeft;
      const slideWidth = this.slider.clientWidth;
      const index = Math.round(slideScrollPosition / slideWidth) + 1;

      if (this.currentCounter) {
        this.currentCounter.textContent = index;
      }

      const activeSlide = this.slides[index - 1];
      if (activeSlide?.dataset.mediaId) {
        this.setActiveMedia(activeSlide.dataset.mediaId);
      }

      if (this.prevButton) {
         this.prevButton.toggleAttribute('disabled', slideScrollPosition === 0);
      }
      if (this.nextButton) {
         this.nextButton.toggleAttribute('disabled', slideScrollPosition + slideWidth >= this.slider.scrollWidth - 5);
      }
    }
  }

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGallery);
  }

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.section = this.closest('[data-section]');
      this.sectionId = this.section?.dataset.section || this.dataset.section || '';
      this.variantData = this.section?.querySelector(`#ProductVariants-${this.sectionId}`)?.textContent || '[]';
      this.variants = JSON.parse(this.variantData);
      this.optionCount = Number(this.dataset.optionCount || 0);

      if (!this.section || this.variants.length === 0) return;

      this.addEventListener('change', () => this.updateVariant());
      this.syncSwatches();
      this.updateVariant();
    }

    getSelectedOptions() {
      const selectedOptions = [];

      for (let index = 1; index <= this.optionCount; index += 1) {
        const radio = this.querySelector(`[data-product-option-input][data-option-position="${index}"]:checked`);
        const select = this.querySelector(`[data-product-option-select][data-option-position="${index}"]`);

        if (radio instanceof HTMLInputElement) {
          selectedOptions.push(radio.value);
        } else if (select instanceof HTMLSelectElement) {
          selectedOptions.push(select.value);
        }
      }

      return selectedOptions;
    }

    getCurrentVariant() {
      const selectedOptions = this.getSelectedOptions();

      return this.variants.find((variant) => {
        return selectedOptions.every((value, index) => variant[`option${index + 1}`] === value);
      });
    }

    syncSwatches() {
      this.querySelectorAll('[data-swatch-label]').forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        label.classList.toggle('swatch--active', Boolean(input?.checked));
      });
    }

    updateVariantInput(variant) {
      const input = this.section.querySelector('[data-product-variant-id-input]');
      if (input instanceof HTMLInputElement) {
        input.value = variant?.id || '';
      }
    }

    updatePrice(variant) {
      const moneyFormat = this.section.dataset.moneyFormat;
      const regular = this.section.querySelector('[data-product-price-regular]');
      const compare = this.section.querySelector('[data-product-price-compare]');
      const compareValue = this.section.querySelector('[data-product-price-compare-value]');
      const badge = this.section.querySelector('[data-product-sale-badge]');
      const priceWrapper = this.section.querySelector('[data-product-price-wrapper]');
      const unitPrice = this.section.querySelector('[data-product-unit-price]');
      const unitPriceAmount = this.section.querySelector('[data-product-unit-price-amount]');
      const unitPriceReference = this.section.querySelector('[data-product-unit-price-reference]');

      if (!(regular instanceof HTMLElement) || !(priceWrapper instanceof HTMLElement)) return;

      if (!variant) {
        regular.textContent = '';
        if (compare instanceof HTMLElement) compare.hidden = true;
        if (badge instanceof HTMLElement) badge.hidden = true;
        if (unitPrice instanceof HTMLElement) unitPrice.hidden = true;
        priceWrapper.classList.remove('price--on-sale');
        return;
      }

      regular.textContent = formatProductMoney(variant.price, moneyFormat);

      const isOnSale = Number(variant.compare_at_price) > Number(variant.price);
      priceWrapper.classList.toggle('price--on-sale', isOnSale);

      if (compare instanceof HTMLElement && compareValue instanceof HTMLElement) {
        compare.hidden = !isOnSale;
        compareValue.textContent = isOnSale ? formatProductMoney(variant.compare_at_price, moneyFormat) : '';
      }

      if (badge instanceof HTMLElement) {
        badge.hidden = !isOnSale;
      }

      const hasUnitPrice = Number(variant.unit_price) > 0;
      if (unitPrice instanceof HTMLElement) {
        unitPrice.hidden = !hasUnitPrice;
      }

      if (hasUnitPrice && unitPriceAmount instanceof HTMLElement && unitPriceReference instanceof HTMLElement) {
        unitPriceAmount.textContent = formatProductMoney(variant.unit_price, moneyFormat);
        const referenceValue = Number(variant.unit_price_reference_value) !== 1 ? `${variant.unit_price_reference_value} ` : '';
        unitPriceReference.textContent = `${referenceValue}${variant.unit_price_reference_unit || ''}`.trim();
      }
    }

    updateButton(variant) {
      const addButton = this.section.querySelector('[data-product-add-button]');
      const addButtonLabel = this.section.querySelector('[data-product-add-button-label]');
      const dynamicCheckout = this.section.querySelector('[data-product-dynamic-checkout]');
      const status = this.section.querySelector('[data-product-status]');
      const addToCartLabel = this.section.dataset.addToCartLabel || 'Add to cart';
      const soldOutLabel = this.section.dataset.soldOutLabel || 'Sold out';

      if (!(addButton instanceof HTMLButtonElement) || !(addButtonLabel instanceof HTMLElement)) return;

      if (!variant) {
        addButton.disabled = true;
        addButtonLabel.textContent = soldOutLabel;
        if (dynamicCheckout instanceof HTMLElement) dynamicCheckout.hidden = true;
        if (status instanceof HTMLElement) status.textContent = 'The selected option combination is unavailable.';
        return;
      }

      addButton.disabled = !variant.available;
      addButtonLabel.textContent = variant.available ? addToCartLabel : soldOutLabel;

      if (dynamicCheckout instanceof HTMLElement) {
        dynamicCheckout.hidden = !variant.available;
      }

      if (status instanceof HTMLElement) {
        status.textContent = variant.available ? `${variant.title} selected.` : `${variant.title} is sold out.`;
      }
    }

    updateMedia(variant) {
      if (!variant?.featured_media_id) return;

      const gallery = this.section.querySelector('media-gallery');
      if (gallery instanceof MediaGallery) {
        gallery.scrollToMedia(variant.featured_media_id);
      }
    }

    emitVariantChange(variant) {
      this.section.dispatchEvent(
        new CustomEvent('product:variant-change', {
          bubbles: true,
          detail: {
            variant,
            formattedPrice: variant ? formatProductMoney(variant.price, this.section.dataset.moneyFormat) : '',
          },
        })
      );
    }

    updateVariant() {
      const variant = this.getCurrentVariant();
      this.syncSwatches();
      this.updateVariantInput(variant);
      this.updatePrice(variant);
      this.updateButton(variant);
      this.updateMedia(variant);
      this.emitVariantChange(variant);
    }
  }

  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.slideshow__slide');
      this.dots = this.querySelectorAll('.slideshow__dot');
      this.prevBtn = this.querySelector('.slideshow__arrow--prev');
      this.nextBtn = this.querySelector('.slideshow__arrow--next');
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed) || 5000;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index)));
      });

      if (this.autoplay) this.startAutoplay();

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });
    }

    goTo(index) {
      this.slides[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex]?.classList.remove('is-active');
      this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

      this.currentIndex = (index + this.slides.length) % this.slides.length;

      this.slides[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex]?.classList.add('is-active');
      this.dots[this.currentIndex]?.setAttribute('aria-selected', 'true');
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.speed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  if (!customElements.get('slideshow-component')) {
    customElements.define('slideshow-component', SlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
